"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputAmount = void 0;
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _Input = require("../../../elements/input/Input");
var _react = _interopRequireWildcard(require("react"));
var _CurrencySelector = require("../../currency-selector/CurrencySelector");
var _inputAmountModule = _interopRequireDefault(require("./input-amount.module.scss"));
var _currencySymbolMap = _interopRequireDefault(require("currency-symbol-map"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _classnames = _interopRequireDefault(require("classnames"));
var _noop = require("../../../utils/noop");
var _amountHelper = require("../../../utils/amount/amountHelper");
var _excluded = ["id", "name", "value", "onChange", "disabled", "showCurrencySelect", "popularCurrencies", "allowNegative", "data-testid", "onBlur", "onFocus", "className", "containerClassName", "max", "allowedCurrencies", "hidePopularCurrencies", "showCurrencyCode"];
var InputAmount = function InputAmount(_ref) {
  var id = _ref.id,
    name = _ref.name,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? {
      code: 'GBP'
    } : _ref$value,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    showCurrencySelect = _ref.showCurrencySelect,
    popularCurrencies = _ref.popularCurrencies,
    _ref$allowNegative = _ref.allowNegative,
    allowNegative = _ref$allowNegative === void 0 ? false : _ref$allowNegative,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? 'inputAmount' : _ref$dataTestid,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? _noop.noop : _ref$onBlur,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? _noop.noop : _ref$onFocus,
    className = _ref.className,
    containerClassName = _ref.containerClassName,
    max = _ref.max,
    allowedCurrencies = _ref.allowedCurrencies,
    hidePopularCurrencies = _ref.hidePopularCurrencies,
    showCurrencyCode = _ref.showCurrencyCode,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(function () {
      return (0, _amountHelper.amountToString)(value);
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    stringValue = _useState2[0],
    setStringValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  (0, _react.useEffect)(function () {
    /* istanbul ignore else */
    if (!isFocused) {
      setStringValue((0, _amountHelper.amountToString)(value));
    }
  }, [value, isFocused]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    onBlur(e);
    setStringValue((0, _amountHelper.amountToString)(value));
    setIsFocused(false);
  }, [onBlur, value]);
  var handleFocus = (0, _react.useCallback)(function (e) {
    onFocus(e);
    setIsFocused(true);
  }, [onFocus]);
  var handleAmountChange = (0, _react.useCallback)(function (_ref2) {
    var floatValue = _ref2.floatValue,
      stringValue = _ref2.value;
    if (max && floatValue > max) {
      onChange((0, _objectSpread2.default)((0, _objectSpread2.default)({}, value), {}, {
        amount: max
      }), true);
      setStringValue(max.toFixed(2));
      return;
    }
    var newValue = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, value), {}, {
      amount: floatValue
    });
    onChange(newValue, true);
    setStringValue(stringValue);
  }, [onChange, value, max]);
  var handleCurrencyChange = (0, _react.useCallback)(function (_ref3) {
    var currentTarget = _ref3.currentTarget;
    onChange((0, _objectSpread2.default)((0, _objectSpread2.default)({}, value), {}, {
      code: currentTarget.value
    }), true);
  }, [value, onChange]);
  var sign = (0, _currencySymbolMap.default)(value.code);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_inputAmountModule.default['input-amount'], containerClassName)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _inputAmountModule.default['input-amount__sign']
  }, sign), /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, Object.assign({}, props, {
    customInput: _Input.Input,
    "data-testid": dataTestId,
    id: id,
    name: name,
    value: stringValue,
    onValueChange: handleAmountChange,
    disabled: disabled,
    decimalScale: 2,
    onBlur: handleBlur,
    onFocus: handleFocus,
    className: (0, _classnames.default)(_inputAmountModule.default['input-amount__input'], showCurrencySelect && _inputAmountModule.default['input-amount--select-enabled'], className),
    allowNegative: allowNegative
  })), showCurrencySelect && /*#__PURE__*/_react.default.createElement(_CurrencySelector.CurrencySelector, {
    asSuffix: true,
    onChange: function onChange(value) {
      return handleCurrencyChange({
        currentTarget: {
          value: value
        }
      });
    },
    className: _inputAmountModule.default['input-amount__selected-code'],
    value: value.code,
    id: "".concat(id, ".currency"),
    "data-testid": "".concat(dataTestId, ".currency"),
    name: "".concat(name, ".currency"),
    disabled: disabled,
    popularCurrencies: popularCurrencies,
    allowedCurrencies: allowedCurrencies,
    hidePopularCurrencies: hidePopularCurrencies
  }), showCurrencyCode && /*#__PURE__*/_react.default.createElement("div", {
    className: _inputAmountModule.default['input-amount__code']
  }, value.code));
};
exports.InputAmount = InputAmount;